<template>
  <form v-on:submit="save">
    <div class="card card-info">
      <div class="card-header with-border">
        <h3 class="card-title">Department Coordinator</h3>
      </div>
      <!-- /.card-header -->
      <!-- form start -->

      <div class="card-body">
        <div class="row">
          <div class=" col-md-4">
            <div class="form-group">
              <label>Program </label>
              <select class="form-control" v-model="cr.ProgramID" v-on:change="loadBatchForCourses()" required="required">
                <option value="0" disabled="disabled">--Select Program--</option>
                <option v-for="item in allprograms" v-bind:value="item.ProgramID">{{item.ProgramName}}</option>
              </select>
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group">
              <label>Session</label>
              <select class="form-control" v-model="cr.SessionID" v-on:change="loadCourses()" required="required">
                <option value="0" disabled="disabled">--Select Session--</option>
                <option v-for="item in crssessions" v-bind:value="item.SessionID">{{item.Name}}</option>
              </select>
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group">
              <label>Courses</label>
              <select class="form-control" v-model="cr.RoadMapChildID" v-on:change="loadStudents()" required="required">
                <option value="0" disabled="disabled">--Select Course--</option>
                <option v-for="item in courses" v-bind:value="item.RoadMapChildID">{{item.CourseName}}</option>
              </select>
            </div>
          </div>

        </div>

        <div class="row">

          <div class="col-md-12" v-show="cr.RoadMapChildID != 0">

            <div class="form-group">
              <label>Sections</label>
              <div v-for="(item, ind) in sections" class="checkbox">
                <label>
                  <input style="margin-top: 0px;" type="checkbox" v-model="item.Selected" v-on:change="sectionChange(ind)">
                  {{item.Batch}}
                </label>
              </div>
              <div>
                Selected Students <b>{{students.filter((x) => {return x.Selected;}).length}}</b>
              </div>
              <br />
              <table id="tblStudent" class="table table-bordered table-color table-hover">
                <thead class="bg-info">
                  <tr>
                    <th>Roll No.</th>
                    <th>Reg. No.</th>
                    <th>
                      <div class="checkbox">
                        <label>
                          <input style="margin-top: 0px;" type="checkbox" v-model="stcheck" v-on:change="masterCheckStudents()">
                          Student Name
                        </label>
                      </div>
                    </th>
                    <th>Father Name</th>
                    <th>Batch</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in students">
                    <td>{{item.RollNo}}</td>
                    <td>{{item.RegistrationNo}}</td>
                    <td>
                      <div class="checkbox">
                        <label>
                          <input style="margin-top: 0px;" type="checkbox" v-model="item.Selected">
                          {{item.Name}}
                        </label>
                      </div>
                    </td>
                    <td>{{item.FathersName}}</td>
                    <td>{{item.Batch}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!--Button -->
      <div class="row" style="text-align: right; padding-left: 32px; padding-right: 32px; margin-top: 10px; margin-bottom: 30px; padding-bottom: 20px;">
        <div class="col-md-12">
          <button class="btn btn-primary" type="button" data-toggle="modal" data-target="#myModal">Actions</button>
          <button class="btn btn-danger" type="button" v-on:click="cancel()">Cancel</button>
        </div>
      </div>
    </div>

    <div id="myModal" class="modal fade" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title pull-left" style="width: 200px">Actions</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-6">
                <label>Action</label>
                <select class="form-control" v-model="selAction">
                  <option value="1">Drop</option>
                  <option value="0">Delete</option>
                </select>
              </div>
              <div class="col-md-6" v-if="selAction == '1'">
                <label>Date</label>
                <input type="date" class="form-control" v-model="date" />
              </div>
              <div class="col-md-12" v-if="selAction == '1'">
                <label>Remarks</label>
                <input class="form-control" v-model="remarks" />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn btn-success" >Save</button>
            <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
          </div>
        </div>

      </div>
    </div>
  </form>
  
</template>

<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return {
        programs: [],
        allprograms: [],
        sessions: [],
        crssessions: [],
        st: { ProgramID: 0, SessionID: 0 },
        cr: { ProgramID: 0, SessionID: 0, RoadMapChildID: 0 },
        students: [],
        courses: [],
        sections: [],
        prereq: false,
        stcheck: true,
        crcheck: false,
        note: '',
        summary: [],

        selAction: '1',
        date: '',
        remarks: ''
      }
    },
    created: function () {
      this.loadPrograms();
    },
    updated: function () {
      $('#tblStudent').DataTable();
      $('#tblCourse').DataTable();
    },

    methods:
    {
      loadPrograms() {
        var vm = this;
        startReq();
        axios.post('/api/DCApi/loadAllPrograms')
          .then(function (p) {
            if (p.data.status) {
              vm.allprograms = p.data.prog;
              vm.date = p.data.date;
              endReq();
            }
        
          });

        endReq();
      },

      loadBatch() {
        var vm = this;
        startReq();
        axios.post('/api/DCApi/loadSessions?progID=' + vm.st.ProgramID)
          .then(function (response) {
            vm.sessions = response.data.record;
            vm.st.SessionID = 0;
            vm.students = [];
            var table = $('#tblStudent').DataTable();
            table.destroy();
            endReq();
          });
      },

      loadBatchForCourses() {
        var vm = this;
        startReq();
        axios.post('/api/DCApi/loadSessions?progID=' + vm.cr.ProgramID)
          .then(function (response) {
            vm.crssessions = response.data.record;
            vm.cr.SessionID = 0;
            vm.students = [];
            var table = $('#tblStudent').DataTable();
            table.destroy();
            endReq();
          });
      },

      loadCourses() {
        var vm = this;
        startReq();
        axios.post('/api/DCApi/loadCourses?progID=' + vm.cr.ProgramID + '&sesID=' + vm.cr.SessionID)
          .then(function (response) {
            vm.courses = [];
            vm.courses = response.data.record;
            endReq();
          });
      },

      loadStudents() {
        var vm = this;
        startReq();
        axios.post('/api/DCApi/loadStudentForDrop?crsID=' + vm.cr.RoadMapChildID)
          .then(function (response) {
            var table = $('#tblStudent').DataTable();
            table.destroy();
            vm.students = response.data.record;
            vm.sections = response.data.sel;

            endReq();
          });
      },

      masterCheckStudents() {
        var vm = this;
        startReq();
        vm.students.forEach(function (item) {
          item.Selected = vm.stcheck
        })
        endReq();
      },

      masterCheckCourses() {
        var vm = this;
        startReq();
        vm.courses.forEach(function (item) {
          item.Selected = vm.crcheck
        })
        endReq();
      },

      sectionChange(ind) {
        var vm = this;
        var ses = vm.sections[ind];
        console.log(ses);
        vm.students.forEach(function (item) {
          if (ses.Selected && item.SectionID == ses.SectionID)
            item.Selected = true;
          else if (!ses.Selected && item.SectionID == ses.SectionID)
            item.Selected = false;
        });
      },

      save(e) {
        e.preventDefault()
        var vm = this;

        var st = vm.students.filter((x) => { return x.Selected; });
        if (st.length == 0) {
          toastr.error("No student selected");
          return;
        }


        if (this.selAction == '') {
          toastr.error("please select action");
          return;
        }

        if (this.selAction == '1' && this.date == '') {
          toastr.error("please select date");
          return;
        }

        startReq();
        axios.post('/api/DCApi/saveBulkDrop?crsID=' + vm.cr.RoadMapChildID + '&act=' + vm.selAction + '&date=' + vm.date + '&remarks=' + vm.remarks, {
          students: st,
          //action: vm.selAction 
        })
          .then(function (res) {
            endReq();

            if (res.data.status) {
              toastr.success("Saved Successfully", "Done!");

              vm.clear();
            }
            else {
              toastr.error("Internal error occurred");
            }
          });
      },

      delete() {

        var vm = this;

        var st = vm.students.filter((x) => { return x.Selected; });
        if (st.length == 0) {
          toastr.error("No student selected");
          return;
        }

        var cr = vm.courses.filter((x) => { return x.Selected; });
        if (cr.length == 0) {
          toastr.error("No Course selected");
          return;
        }

        startReq();
        axios.post('/api/DCApi/saveEnrollments?preReq=' + vm.prereq, {
          students: st,
          courses: cr,
        })
          .then(function (res) {
            endReq();

            if (res.data.status) {
              toastr.success("Saved Successfully", "Done!");
              vm.summary = res.data.summary;
              //$('#tblSummary').DataTable();
              $('#mdlSummary').modal('show');
              vm.clear();
            }
            else {
              toastr.error("Internal error occurred");
            }
          })
      },

      clear() {
        this.sessions = [];
        this.crssessions = [];
        this.st = { ProgramID: 0, SessionID: 0 };
        this.cr = { ProgramID: 0, SessionID: 0, RoadMapChildID: 0 };
        this.students = [];
        this.courses = [];
        this.sections = [];
        this.prereq = false;
        var table = $('#tblStudent').DataTable();
        table.destroy();
        this.selAction = '1';
        this.date = '';
        this.remarks = '';
        $('#myModal').modal('hide');
      },

      cancel() {
        window.location.reload();
      }
    }
  })
</script>



// WEBPACK FOOTER //
// src/components/DC/bulkCourseDrop.vue